import ValidationInterface from '@/plans/common/validation-interface';

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts() {
    return this.current(['zsched']).conflict(['zsched']);
  }
}
